import { useEffect, useState } from 'react';
import { getAllEatInfo } from '../../../util/DatabaseUtil';
import { Circles } from 'react-loading-icons';

const EatTab = () => {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCompanyData = async () => {
      try {
        setLoading(true);
        const response = await getAllEatInfo();
        setCompanies(response.businesses || []);
      } catch (error) {
        console.error('Error fetching company info:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCompanyData();
  }, []);
  console.log(companies);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-40">
        <Circles className="text-white" />
      </div>
    );
  }

  return (
    <div
      className="grid place-items-center lg:grid-cols-4 md:grid-cols-3 
    grid-cols-1 gap-y-10 gap-x-6 px-4 md:px-16 lg:px-56 2xl:grid-cols-5 mb-4"
    >
      {companies.map((item, id) => (
        <a
          href={`/business/${item._id}`}
          key={id}
          target="_blank"
          rel="noopener noreferrer"
          className="w-full max-w-xs bg-primary border-2 border-white rounded-3xl shadow-xl hover:shadow-2xl transform transition-all duration-300 hover:-translate-y-1 group"
        >
          {/* Image Section */}
          <div className="relative h-48 bg-gray-50 flex items-center justify-center overflow-hidden rounded-t-3xl">
            {item.logo?.data ? (
              <img
                src={`data:${item.logo.contentType};base64,${item.logo.data}`}
                alt={item.name}
                className="h-full w-full object-contain group-hover:scale-105 transition-transform duration-300"
              />
            ) : (
              <div className="text-gray-400 text-sm">No Image</div>
            )}

            {/* Overlay for name */}
            <div className="absolute bottom-0 left-0 w-full bg-gradient-to-t from-black/70 to-transparent px-3 py-1 flex justify-end">
              {item.category?.length > 0 && (
                <span className="inline-block text-sm font-medium bg-secondary text-primary px-2 py-1 rounded-full capitalize">
                  {item.category[0].replace(/_/g, ' ')}
                </span>
              )}
            </div>
          </div>

          {/* Details Section */}
          <div className="px-5 py-2">
            <h3 className="text-white text-lg  font-bold truncate">
              {item.name}
            </h3>
          </div>
        </a>
      ))}
    </div>
  );
};

export default EatTab;
